import React, { useState } from 'react';
import { Form, Input, Select, Button, Row, Col } from 'antd';
import { ONBOARDING_CURRENCIES } from '../../../../../../Onboarding/onboardingConstants';
import { buildOrgUserInviteeUpdateBody } from '../../../../../../Onboarding/onboardingApi';

const FormItem = Form.Item;
const { Option } = Select;

function EditOrgUserInviteeForm({ form, record, loading, onSave, onCancel }) {
  const { getFieldDecorator } = form;
  const raw = record?.raw || {};
  const [saving, setSaving] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    form.validateFields(async (err, fieldsValue) => {
      if (err) return;

      const inviteeId = raw.id ?? record?.inviteeId ?? record?.uploadId;
      const body = buildOrgUserInviteeUpdateBody(
        raw,
        {
          email: String(fieldsValue.email ?? '').trim(),
          firstName: String(fieldsValue.firstName ?? '').trim() || null,
          lastName: String(fieldsValue.lastName ?? '').trim() || null,
          fullBusinessname: String(fieldsValue.fullBusinessName ?? '').trim() || null,
          tradingName: String(fieldsValue.tradingName ?? '').trim() || null,
          businessRegistrationNumber: String(fieldsValue.registrationNumber ?? '').trim() || null,
          planName: String(fieldsValue.planName ?? '').trim() || null,
          currency: fieldsValue.currency || null,
        },
        inviteeId,
      );

      setSaving(true);
      try {
        await onSave(body);
        form.resetFields();
      } finally {
        setSaving(false);
      }
    });
  };

  const isBusy = loading || saving;

  return (
    <Form layout="vertical" className="add-users-manual-form">
      <FormItem label="Email">
        {getFieldDecorator('email', {
          initialValue: record?.email || raw.email,
          validateTrigger: 'onBlur',
          rules: [
            { required: true, message: 'Please enter the user email.' },
            { type: 'email', message: 'Please enter a valid email.' },
          ],
        })(<Input placeholder="user@example.com" disabled={isBusy} spellCheck={false} />)}
      </FormItem>
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <FormItem label="First name">
            {getFieldDecorator('firstName', {
              initialValue: raw.firstName || record?.assignName?.split(' ')?.[0] || '',
              rules: [{ required: true, whitespace: true, message: 'Please enter the first name.' }],
            })(<Input disabled={isBusy} />)}
          </FormItem>
        </Col>
        <Col xs={24} sm={12}>
          <FormItem label="Last name">
            {getFieldDecorator('lastName', {
              initialValue: raw.lastName || '',
              rules: [{ required: true, whitespace: true, message: 'Please enter the last name.' }],
            })(<Input disabled={isBusy} />)}
          </FormItem>
        </Col>
      </Row>
      <FormItem label="Business name (optional)">
        {getFieldDecorator('fullBusinessName', {
          initialValue: raw.fullBusinessname || raw.fullBusinessName || '',
        })(<Input placeholder="Legal registered name" disabled={isBusy} />)}
      </FormItem>
      <FormItem label="Trading name (optional)">
        {getFieldDecorator('tradingName', {
          initialValue: raw.tradingName || '',
        })(<Input placeholder="Name used day-to-day" disabled={isBusy} />)}
      </FormItem>
      <FormItem label="Business reg. no. (optional)">
        {getFieldDecorator('registrationNumber', {
          initialValue: raw.businessRegistrationNumber || raw.registrationNumber || '',
        })(<Input placeholder="ABN / ACN" disabled={isBusy} />)}
      </FormItem>
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <FormItem label="Plan name (optional)">
            {getFieldDecorator('planName', {
              initialValue: raw.planName || record?.planName || '',
            })(<Input disabled={isBusy} />)}
          </FormItem>
        </Col>
        <Col xs={24} sm={12}>
          <FormItem label="Currency (optional)">
            {getFieldDecorator('currency', {
              initialValue: raw.currency || undefined,
            })(
              <Select placeholder="Select currency" disabled={isBusy} allowClear>
                {ONBOARDING_CURRENCIES.map((currencyOption) => (
                  <Option key={currencyOption.value} value={currencyOption.value}>
                    {currencyOption.label}
                  </Option>
                ))}
              </Select>,
            )}
          </FormItem>
        </Col>
      </Row>
      <FormItem>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Button block disabled={isBusy} onClick={onCancel}>
              Cancel
            </Button>
          </Col>
          <Col xs={24} sm={12}>
            <Button type="primary" block loading={isBusy} onClick={submit}>
              Save changes
            </Button>
          </Col>
        </Row>
      </FormItem>
    </Form>
  );
}

export default Form.create()(EditOrgUserInviteeForm);
